import React from "react";
import { OptionNameValuePair } from "../../../../lib/interfaces/types";
import { cn } from "../../../../lib/utils";
import SelectDropdownV2 from "../../selectdropdown/v2";

interface ISelectCellProps {
  name: string;
  value?: string;
  isEditable?: boolean;
  onChange?: (value: string) => void;
  options?: OptionNameValuePair<string>[];
  className?: string;
  rootContainerClassName?: string;
  labelClassName?: string;
  showTitleSubTitle?: boolean;
  titleClassName?: string;
  subTitleClassName?: string;
  showTooltip?: boolean;
  footer?: React.ReactNode;
  dropdownClassName?: string;
  allowOpenWhenReadOnly?: boolean;
  hideDisabledOptions?: boolean;
  hideChevron?: boolean;
  optionClassName?: string;
}

const SelectCell: React.FC<ISelectCellProps> = ({
  value,
  isEditable,
  onChange,
  options = [],
  className,
  rootContainerClassName,
  labelClassName,
  showTitleSubTitle = false,
  titleClassName,
  subTitleClassName,
  showTooltip = false,
  footer,
  dropdownClassName,
  name,
  allowOpenWhenReadOnly = false,
  hideDisabledOptions = false,
  hideChevron = true,
  optionClassName,
}) => {
  if (!isEditable && !allowOpenWhenReadOnly) {
    const selectedOption = options.find((opt) => opt.value === value);

    if (showTooltip) {
      return (
        <SelectDropdownV2
          name={name}
          placeholder="Select option"
          options={options}
          selectedOption={selectedOption}
          disabled
          onSelectionChange={() => {}}
          containerClassName={cn("w-full", rootContainerClassName)}
          labelClassName={labelClassName}
          hideChevron={hideChevron}
          showTitleSubTitle={showTitleSubTitle}
          titleClassName={titleClassName}
          subTitleClassName={subTitleClassName}
          showTooltip={showTooltip}
          footer={footer}
          dropdownClassName={dropdownClassName}
          hideDisabledOptions={hideDisabledOptions}
          optionClassName={optionClassName}
        />
      );
    }
    return (
      <div className={cn("px-2 py-1 text-sm", className)}>
        {selectedOption?.display_component || selectedOption?.name || value || "-"}
      </div>
    );
  }

  const selectedOption = options?.find((opt) => opt.value === value);
  const readOnlyMode = !isEditable && allowOpenWhenReadOnly;
  const readOnlyOptions = readOnlyMode
    ? options.map((opt) => ({ ...opt, disabled: true }))
    : options;

  return (
    <SelectDropdownV2
      name={name}
      placeholder="Select option"
      options={readOnlyOptions}
      selectedOption={selectedOption}
      onSelectionChange={(selected) => {
        if (readOnlyMode) return;
        if (onChange && selected) {
          onChange(selected.value);
        }
      }}
      containerClassName={cn(
        "w-full",
        "focus-within:bg-[#F3F4F6] focus-within:border-[#4B5563]",
        rootContainerClassName
      )}
      labelClassName={cn("px-2 py-1 text-xs", labelClassName)}
      hideChevron={hideChevron ?? true}
      showTitleSubTitle={showTitleSubTitle}
      titleClassName={titleClassName}
      subTitleClassName={subTitleClassName}
      showTooltip={showTooltip}
      footer={footer}
      dropdownClassName={cn("-ml-[10px]", dropdownClassName)}
      hideDisabledOptions={hideDisabledOptions}
      optionClassName={optionClassName}
    />
  );
};

export default SelectCell;
